import styled from 'styled-components';

export const ScLoader = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
